import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly oauthService = inject(OAuthService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.oauthService.hasValidAccessToken()) {
      const changedReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${this.oauthService.getAccessToken()}`),
      });
      return next.handle(changedReq);
    } else {
      return next.handle(req);
    }
  }
}
